import React, { Component } from "react";
// react component that creates a form divided into multiple steps
import StepZilla from "react-stepzilla";
import { Grid, Row, Col } from "react-bootstrap";

import Card from "../../../components/Card/Card.jsx";

import Step1 from "./Step1.jsx";
import Step2 from "./Step2.jsx";
import Step3 from "./Step3.jsx";



class RegisterWizard extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.sampleStore = {
            firstname: '',
            lastname: '',
            company: '',
            email: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            phone: '',
            SubscriptionType: '',
            SubscriptionMultiShopCount: 0,
            SubscriptionDate: '',
            SubscriptionPrice: 0,
            Userid: '',
            Password: '',
            ConfirmPassword: '',
            Kioskid: '',
            KioskPassword: '',
            KioskConfirmPassword: '',
            number: '',
            name: '',
            expiry: '',
            cvc: '',
            issuer: '',
            focused: '',
            formData: null,
            sentEmail: false
        };
    }

    componentDidMount() {}

    componentWillUnmount() {}

    getStore() {
        return this.sampleStore;
    }

    updateStore(update) {
        this.sampleStore = {
            ...this.sampleStore,
            ...update,
        }
    }

    render() {
    const steps = [
        { name: "Tell us about yourself", component: <Step1 getStore={() => (this.getStore())} updateStore={(u) => {this.updateStore(u)}}/> },
        { name: "Setup Subscription", component: <Step2 getStore={() => (this.getStore())} updateStore={(u) => {this.updateStore(u)}}/> },
        { name: "Payment & Finishing up", component: <Step3 getStore={() => (this.getStore())} updateStore={(u) => {this.updateStore(u)}}/> }
    ];
    return (
        <div className="main-content" style={{backgroundImage: "url("+require("../../../assets/img/matrix.jpg")+")", backgroundSize: "cover",
            backgroundPosition: "center center"}}>
        <Grid fluid>
          <Row>
            <Col md={8} mdOffset={2}>
              <Card
                wizard
                id="wizardCard"
                textCenter
                title="Register a Tenant"
                category="Setup your tenant profile and subscription"
                content={
                  <StepZilla
                    steps={steps}
                    stepsNavigation={false}
                    nextButtonCls="btn btn-prev btn-info btn-fill pull-right btn-wd"
                    backButtonCls="btn btn-next btn-default btn-fill pull-left btn-wd"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default RegisterWizard;



// WEBPACK FOOTER //
// ./src/views/Forms/RegisterWizard/RegisterWizard.jsx